import { ColumnDef } from '@tanstack/react-table'
import { Clinic } from '@magnetar/admin-api-interfaces'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { useViewModeActions } from '@/hooks/useViewModeActions'

export const columns: ColumnDef<Clinic>[] = [
  {
    accessorKey: 'clinic_id',
    header: 'ID',
    cell: ({ row }) => {
      const id: number = row.getValue('clinic_id')
      return (
        <Badge variant="outline" className="font-medium">
          {id}
        </Badge>
      )
    },
  },
  {
    accessorKey: 'clinic_name',
    header: '診所名稱',
    cell: ({ row }) => {
      const clinic = row.original
      return (
        <div>
          {clinic.clinic_name}
          {clinic.alias && (
            <span className="text-muted-foreground ml-1">({clinic.alias})</span>
          )}
        </div>
      )
    },
  },
  {
    accessorKey: 'manager_name',
    header: '聯絡人',
  },
  {
    accessorKey: 'phone',
    header: '電話',
  },
  {
    accessorKey: 'address',
    header: '地址',
  },
  {
    accessorKey: 'is_active',
    header: '狀態',
    cell: ({ row }) => {
      const is_active: boolean = row.getValue('is_active')
      return (
        <Badge variant={is_active ? 'default' : 'secondary'}>{is_active ? '啟用' : '停用'}</Badge>
      )
    },
  },
  {
    id: 'actions',
    cell: function ActionsCell({ row }) {
      const clinic = row.original
      const { setClinicMode } = useViewModeActions()

      const handleEdit = () => {
        setClinicMode(clinic.clinic_id)
      }

      return (
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" onClick={handleEdit}>
            編輯診所
          </Button>
        </div>
      )
    },
  },
]
